
import Spinner from "../../../components/common/Spinner/Spinner";

import {
  Grid,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
  Snackbar,
  Alert,
  IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import classNames from "classnames";
import { result, toUpper } from "lodash"
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./List.module.scss";
import ModalEditLanguage from "../ModalEditLanguage";
import { search2 } from "../../../assets/icons";
import Search from "../../../components/common/Search/Search";
import { useNavigate, useParams } from "react-router";
import { AppState } from '@configs/store/rootReducer';
import { openToast } from '@redux/toast/actions';
import { fetchLanguageRequest, fetchTodoRequest, fetchWordRequest } from "@redux/Language/actions";
import ModalAddWord from "../ModalAddWord";
import PaginationUI from "@components/common/Pagination/Pagination";
import Toast from "@components/common/Toast/toast";

const List = () => {
  const dispatch = useDispatch();
  const queryParam = useParams();

  const [searchText, setSearchText] = useState("");
  // const [keyShowDelete, setKeyShowDelete] = useState(-1);
  const [selectedArray, setSelectedArray] = useState<any>([]);
  const [page, setPage] = useState(1)
  const [editItem, setEditItem] = useState<any>(null);
  const [initValue, setInitValue] = useState<any>(null);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [anchorElAdd, setAnchorElAdd] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const openAdd = Boolean(anchorElAdd);

  const [list, setList] = useState<any>({});
  // const [handleEdit, setHandleEdit] = useState<any>({})
  const toast = useSelector((state: AppState) => state.toOpen);
  const language = useSelector((state: AppState)=> state.toTranslate.languages)
  const words = useSelector((state: AppState)=> state.toTranslate.words)
  const metadata = useSelector((state: AppState)=> state.toTranslate.metadata)
  const [LANG, setLang] = useState<any>([])
  const message = useSelector((state: AppState) => state.toTranslate.message)
  const loading = useSelector((state:AppState) => state.toTranslate.loading)
  const { languageReducer } = useSelector((state: any) => ({
    languageReducer: state?.languageReducer,
  }));  
  // const { pending } = useSelector((state: any) => ({
  //   pending: state?.languageReducer,
  // })); 
  useEffect(()=>{
    dispatch(fetchLanguageRequest());
    dispatch(fetchWordRequest({ params: { title: searchText, page }}));
  },[toast.open, loading])
  const pages = Math.ceil(metadata?.total / metadata?.limit)
  useEffect(()=>{
    setLang(language)
    setList(words)
    if(message ==="update word's content success" || message ==="OK" || message ==="Word is not existed! >> Create new word translate"){
      dispatch(openToast({
        severity:"success",
        text:"Update Word Successful!",
        open:true
      })) 
    }
    if(message ==="Create success"){
      dispatch(openToast({
        severity:"success",
        text:"Create New Language success!",
        open:true
      })) 
    }
    if(message ==="Language is exit, try again"){
      dispatch(openToast({
        severity:"error",
        text:"Language is exited, try again!",
        open:true
      })) 
    }
  },[language, words, anchorEl])

  const handleClickAdd = (event: React.MouseEvent<HTMLButtonElement>, value: any, keyLang: string, pathLang: any) => {
    setEditItem({
      data: {
        keyLang: value?.content|| value.default,
      },
      wordId: value?._id,
      payload: value?.content|| value.default,
      keyLang: keyLang,
      pathLang: pathLang?.path,
      searchText: searchText
    })
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseAdd = ()=>{
    setAnchorElAdd(null)
  }
 
  
  const handleCloseToast = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return; 
    }
    dispatch(openToast({
                text: "",
                open: false
              }))
  }

  const typingTimeoutRef: any = React.useRef(null);

  const handleSearch = (e:any)=>{
    const data = e.target.value
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }
    typingTimeoutRef.current = setTimeout(async () => {
      setSearchText(data);
      dispatch(fetchWordRequest({ params: { title: data, page: 1 }}));
    }, 1000);
  }
  const handleEdit = async(data:any) => {
    handleClose()
  }
  const handleClickAddWord = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElAdd(event.currentTarget);
  };

  const onChangePage = (e: any, pageNumber: number) => {
    setPage(pageNumber)
    dispatch(fetchWordRequest({ params: { title: searchText, page: pageNumber }}));
  }
  return (
    <React.Fragment>

      <Grid className={styles.ActionWrapper}>
        <Grid container justifyContent="space-between" alignItems="flex-end" sm={12}>
          <Grid item sm={3}>
            <Search onChange={handleSearch}/>
          </Grid>
          <Grid item sm={9}>
                  <IconButton
                  style={{backgroundColor:"#005FA1", marginLeft: "60px"}}
                  color="primary"
                  aria-label="add"
                  className={styles?.AddButton}
                  id="add-button"
                  aria-controls={openAdd ? 'add-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openAdd ? 'true' : undefined}
                  onClick={handleClickAddWord}
                >
                  <AddIcon style={{ color: "#fff" }} />
                </IconButton>
                <ModalAddWord anchorElAdd={anchorElAdd} openAdd={openAdd} handleClose={handleCloseAdd} />
          </Grid>
        </Grid>
      </Grid>

      <Grid className={styles.ContentWrapper}>
      <Grid container direction={"column"} className={styles?.Wrapper}>
        {list && Object.keys(list).length > 0 ? (
          <Table>
            <TableHead sx={{ backgroundColor: '#F6F6F7' }}>
              <TableRow>
                {LANG.map((language:any) =>{
                return(
                  <TableCell align="center" key={language.key}>
                    <Typography className={styles.TableCellTitle} sx={{ fontWeight: '600' }}>
                      {language.name}/{toUpper(language.key)}
                    </Typography>
                  </TableCell>
                  )
                  }
                )}
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {list?.map((element: any, index: any) => {
                return (
                  <TableRow
                    key={index}
                    className={classNames(
                      styles.PaperItem,
                      styles.OrderItem,
                      selectedArray.includes(element.default) && styles.PaperActive
                    )}
                  >
                    {LANG.map((language: any, ind: number) => {
                              const foundWord =  element.translation.filter((word: any) => word.lang === language.key );
                              // console.log("found", foundWord, language, element)
                      return (
                        <>
                          <TableCell align="center" sx={{ maxWidth: '250px' }} key={ind}>
                                <div onClick={(e: any) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  handleClickAdd(e, foundWord.length > 0?foundWord[0]: element, language.key, element);
                                }}>
                                  <p
                                    className={classNames(styles.ColContent)}
                                  >
                                    <span className={styles.ContentLanguage}>{foundWord.length > 0?foundWord[0]?.content: element.default}</span>
                                  </p>
                                </div>
                              
                          </TableCell>
                        </>
                      )}
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        ) : (
          <div className={styles.DataEmpty}>Không có dữ liệu</div>
        )}

        {loading && <Spinner />}

        {metadata?.total && pages > 1 ? (
          <PaginationUI
            isPagination={true}
            count={pages}
            page={page}
            handleChange={(event: any, value: any) => {
              onChangePage(event, value);
            }}
          />
        ) : null}
      </Grid>

      <ModalEditLanguage 
        initValue={editItem} 
        anchorEl={anchorEl} 
        open={open} 
        handleClose={handleClose} 
        handleEdit={handleEdit}
        searchText={searchText}
      />

      {/* <Slide in={selectedArray.length > 0} direction="up">
        <Paper square className={styles.ActionBar}>
          <Grid
            container
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <IconButton onClick={() => handleShowModalConfirm("MANY")}>
              <DeleteIcon />
            </IconButton>
          </Grid>
        </Paper>
      </Slide>

      {isOpenModal && (
        <ModalConfirmDelete
          onClose={handleCloseModalConfirm}
          onSubmit={handleDeletePost}
        />
      )} */}

      {/* <DrawerInfoNew
        onClose={handleOpenDrawerInfoNew}
        open={openDrawerInfoNew}
      /> */}
      </Grid>
      <Toast/>
    </React.Fragment>
  );
};

export default List;
